export const PROVINCE = [
  "Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti", "Avellino",
  "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo", "Biella", "Bologna",
  "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta", "Campobasso", "Caserta",
  "Catania", "Catanzaro", "Chieti", "Como", "Cosenza", "Cremona", "Crotone", "Cuneo", "Enna",
  "Fermo", "Ferrara", "Firenze", "Foggia", "Forlì-Cesena", "Frosinone", "Genova", "Gorizia",
  "Grosseto", "Imperia", "Isernia", "L'Aquila", "La Spezia", "Latina", "Lecce", "Lecco",
  "Livorno", "Lodi", "Lucca", "Macerata", "Mantova", "Massa-Carrara", "Matera", "Messina",
  "Milano", "Modena", "Monza e Brianza", "Napoli", "Novara", "Nuoro", "Oristano", "Padova",
  "Palermo", "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa",
  "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria",
  "Reggio Emilia", "Rieti", "Rimini", "Roma", "Rovigo", "Salerno", "Sassari", "Savona",
  "Siena", "Siracusa", "Sondrio", "Sud Sardegna", "Taranto", "Teramo", "Terni", "Torino",
  "Trapani", "Trento", "Treviso", "Trieste", "Udine", "Varese", "Venezia", "Verbano-Cusio-Ossola",
  "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo",
];

export const TIPI_RICERCA = [
  "Acquisto Casa",
  "Affitto Lungo Termine (Studenti & Lavoro)",
  "Affitto Turistico (Breve/Vacanze)",
];

export const normTipo = (t) =>
  t === "Affitto Residenziale (Lungo Termine)" ? "Affitto Lungo Termine (Studenti & Lavoro)" : t;

export const categoriaTipo = (t) =>
  t === "Acquisto Casa" ? "Acquisto" : (t || "").includes("Turistico") ? "Affitto estivo" : "Affitto studenti/lavoro";

export const cercoLabel = (t) => {
  if (t === "Acquisto Casa") return "CERCO · Acquisto";
  if ((t || "").includes("Turistico")) return "CERCO · Affitto breve";
  return "CERCO · Affitto lungo";
};

export const CARATTERISTICHE = [
  "Spazio Esterno (Terrazzo/Giardino)",
  "Ascensore",
  "Posto Auto/Box",
  "Arredato",
  "Cantina/Solai",
  "Piscina",
];

export const MQ_RANGES = [
  "Fino a 50 mq",
  "50–80 mq",
  "80–120 mq",
  "120–180 mq",
  "Oltre 180 mq",
];

export const DESTINAZIONI = [
  "Residenziale",
  "Studenti",
  "Business / Lavoro",
  "Artigianale / Commerciale",
  "Vacanze",
];

export const colonnaTipo = (t) =>
  t === "Acquisto Casa" ? "acquisto" : (t || "").includes("Turistico") ? "breve" : "lungo";

export const ZONE = [
  "Centro storico",
  "Centro",
  "Semicentro",
  "Periferia",
  "Campagna",
  "Zona mare",
  "Condominio",
  "Casa indipendente",
  "Villetta a schiera",
];

export const CAMERE = ["1", "2", "3", "4", "5+"]

export const BAGNI = ["1", "2", "3+"];

export const TIPI_IMMOBILE = [
  "Casa / Appartamento",
  "Villa / Villetta",
  "Terreno agricolo",
  "Terreno edificabile",
  "Capannone industriale",
  "Posto auto coperto",
  "Posto auto scoperto",
  "Garage / Box",
  "Seminterrato",
  "Locale commerciale",
];

export const PAGAMENTO_ACQUISTO = [
  "Disponibilità immediata (senza mutuo)",
  "Mutuo da valutare (consulenza gratuita disponibile)",
  "Mutuo pre-approvato",
  "Mutuo: studio di fattibilità già fatto",
];
